import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Sidebar from './Sidebar';
import Footer from './Footer';
import Header from '../common/Header';

const PortalLayout = () => {
    const [collapsed, setCollapsed] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);
    const { isLoggedIn } = useAuth();

    // ✅ Guest — no sidebar, full width
    if (!isLoggedIn) {
        return (
            <div className="min-h-screen flex flex-col bg-white">
                <Header onMenuToggle={undefined}/>
                <main className="flex-1">
                    <Outlet />
                </main>
                <Footer />
            </div>
        );
    }

    // ✅ Logged in — sidebar portal
    return (
        <div className="h-screen flex flex-col bg-gray-50 overflow-hidden">
            <Header
                onMenuToggle={() => setMobileOpen(o => !o)}
                sidebarCollapsed={collapsed}
            />
            <div className="flex flex-1 overflow-hidden">
                <Sidebar
                    collapsed={collapsed}
                    setCollapsed={setCollapsed}
                    mobileOpen={mobileOpen}
                    setMobileOpen={setMobileOpen}
                />
                <div id="main-scroll" className="flex-1 flex flex-col min-w-0 overflow-y-auto">
                    <main className="flex-1">
                        <Outlet />
                    </main>
                    <Footer />
                </div>
            </div>
        </div>
    );
};

export default PortalLayout;